
import "./spinner.ui.css";
import iconLoading from "assets/img/v2/icon/icon_loading.gif";

const Spinner = () => {
  return (
    <div className='spinner'>
      <img className="animated" src={iconLoading} />
    </div>
  );
};

export default Spinner;